export default __webpack_public_path__ + "static/media/8-1.39230465.mp3";